export default __webpack_public_path__ + "static/magnifier-ac01af11d8a840acaf1283a8fd210ef2.png";